import { render, staticRenderFns } from "./DismissLink.vue?vue&type=template&id=b52e3ec8&"
import script from "./DismissLink.vue?vue&type=script&lang=js&"
export * from "./DismissLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports